import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList, Td, Tr, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { formatDateToDateTimeDisplay } from '@/utils/formatDateToDateTimeDisplay';
import { PermissionType } from '@/model';
import { EllipsisVerticalIcon } from '@heroicons/react/24/outline';
import { ChakraFeatherIcon } from '@/components/ChakraFeatherIcon';
import { useTranslation } from 'react-i18next';

export interface AccessControlPermissionTypesTableRowProps {
  permissionType: PermissionType;
}

export const AccessControlPermissionTypesTableRow = ({ permissionType }: AccessControlPermissionTypesTableRowProps) => {
  const { t } = useTranslation();

  return (
    <Tr>
      <Link
        to={`/access-control/permission-types/${permissionType?.id}`}
        style={{ display: 'contents', verticalAlign: 'inherit' }}
      >
        <Td w={{ md: '220px' }}>{formatDateToDateTimeDisplay(permissionType?.created_at)}</Td>
        <Td>
          <Text fontWeight='bold'>{permissionType?.name}</Text>
        </Td>

        <Td
          w={{ md: '100px' }}
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          <Menu>
            <MenuButton
              textColor='text.table'
              as={IconButton}
              variant='ghost'
              size='sm'
              icon={<Icon as={EllipsisVerticalIcon} />}
              aria-label={t('pages.access_control_permission_types.components.permission_table_row.aria_label_more_actions')}
            />
            <MenuList textColor='white'>
              <MenuItem
                icon={
                  <Text>
                    <ChakraFeatherIcon name='eye' />
                  </Text>
                }
                as={Link}
                to={`/access-control/permission-types/${permissionType?.id}`}
              >
                <Text>{t('pages.access_control_permission_types.components.permission_table_row.action_view_permissions')}</Text>
              </MenuItem>
            </MenuList>
          </Menu>
        </Td>
      </Link>
    </Tr>
  );
};
